import { SummarizeQuestionnaireInput } from "@/modules/chats/services/ai/ch/__generated__/chQuestionnaireSummarizerQuery.graphql"
import { chQuestionnaireSummarizerQuery } from "@/modules/chats/services/ai/ch/chQuestionnaireSummarizerQuery"
import { deQuestionnaireSummarizerQuery } from "@/modules/chats/services/ai/de/deQuestionnaireSummarizerQuery"
import { Country } from "@/types/__generated__/union-types"

export const questionnaireSummarizerQuery = (country: Country, input: SummarizeQuestionnaireInput) => {
  if (country === "DE") {
    return deQuestionnaireSummarizerQuery(input)
  }
  return chQuestionnaireSummarizerQuery(input)
}
